<template>
  <div class='group relative'>
    <component
      :is='icon'
      class='h-6 w-6'
      :class='[value ? "text-gray-700" : "text-gray-300"]'
    />
    <span
      v-if='value'
      class='absolute inset-x-[-88px] top-full z-10 mt-1 hidden w-[200px] rounded bg-gray-600 p-1 text-center text-xs text-white group-hover:block'
      :class='[value ? "cursor-help" : "cursor-default"]'
    >
      <strong>{{ label }}</strong>: {{ value }}
    </span>
  </div>
</template>

<script lang="ts">
  import { defineComponent } from 'vue'
  import { PaperAirplaneIcon, MailOpenIcon, EyeIcon, CursorClickIcon, ShieldExclamationIcon, ArchiveIcon, CheckCircleIcon } from '@heroicons/vue/outline'

  export default defineComponent({
    name: 'EmailStatusItem',
    components: {
      PaperAirplaneIcon,
      MailOpenIcon,
      EyeIcon,
      CursorClickIcon,
      ShieldExclamationIcon,
      ArchiveIcon,
      CheckCircleIcon,
    },
    props: {
      status: {
        type: String,
        default: '',
      },
      value: {
        type: Boolean,
        default: false,
      },
      label: {
        type: String,
        default: '',
      },
      icon: {
        type: String,
        default: '',
      },
    },
  })
</script>
